// extracted by mini-css-extract-plugin
export var chevronIcon = "_tb-1";
export var edgeToggle = "_tb-0";